import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Box, makeStyles, Typography, Grid } from "@material-ui/core";

import { capitalize } from "../../../../../services";
import { COLORS } from "../../../../../theme/colors";
import { TextInput } from "../../../../../components/base";

const useStyles = makeStyles(() => ({
  heading: {
    display: "flex",
    marginBottom: 50,
  },
  paper: {
    fontWeight: 400,
    color: COLORS.blackShade,
    marginTop: 8,
  },
  box: {
    display: "flex",
  },
  rightDiv: {
    "& .MuiGrid-justify-content-xs-center": {
      justifyContent: "flex-start",
    },
  },
  boldData: {
    fontWeight: 600,
  },
  leftDiv: {
    "& .MuiGrid-spacing-xs-3": {
      width: 350,
    },
  },
  hr: {
    width: 545,
    marginTop: 50,
    marginBottom: 50,
    marginLeft: 0,
  },
}));

const OperatingExpenses = ({ data, onDataChange }) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);
  const currencySymbol = user.currency.symbol;

  const infoFields = [
    {
      key: "property_taxes",
      title: "Property taxes",
      suffix: "%",
    },
    {
      key: "insurance",
      title: "Insurance (Total)",
      suffix: currencySymbol,
    },
    {
      key: "repairs_maintenance",
      title: "Repairs and Maintenance (Total)",
      suffix: currencySymbol,
    },
    {
      key: "property_management_fees",
      title: "Property Management Fees",
      suffix: `${currencySymbol}/Sqft`,
    },
    {
      key: "advertisting",
      title: "Advertising (Total)",
      suffix: currencySymbol,
    },
    {
      key: "payroll",
      title: "Payroll and benefirst (Total)",
      suffix: currencySymbol,
    },
    {
      key: "office_supplies",
      title: "Office Supplies (Total)",
      suffix: currencySymbol,
    },
    {
      key: "phone_internet",
      title: "Phone & Internet (Total)",
      suffix: "",
    },
    {
      key: "electricity",
      title: "Electricity",
      suffix: `${currencySymbol}/Sqft`,
    },
    {
      key: "gas",
      title: "Gas",
      suffix: `${currencySymbol}/Sqft`,
    },
    {
      key: "other_utilites",
      title: "Other utilities",
      suffix: `${currencySymbol}/Sqft`,
    },
    {
      key: "professional_services",
      title: "Professional Services (Total)",
      suffix: currencySymbol,
    },
    {
      key: "misc_expenses",
      title: "Misc Expenses (Total)",
      suffix: currencySymbol,
    },
    {
      key: "rental_expenses_growth",
      title: "Rental Operating Expenses- Annual Growth",
      suffix: "%/year",
    },
  ];

  useState(() => {
    infoFields.forEach((item) => {
      if (item.suffix === `${currencySymbol}/Sqft`)
        item.suffix = `${currencySymbol}/${capitalize(user?.unit_system)}`;
    });
  }, []);

  return (
    <Box>
      <Box className={classes.heading}>
        <Typography variant="h1">Tenancy data - </Typography>&nbsp;
        <Typography style={{ fontSize: 27 }}>Rental Operating Expenses</Typography>
      </Box>
      {infoFields.map((value, i) => {
        return (
          <Grid container spacing={3} key={i} className={classes.leftDiv}>
            <Grid item xs>
              <Typography variant="h5" className={classes.paper}>
                {value.title}
              </Typography>
            </Grid>
            <Grid item xs={8} className={classes.rightDiv}>
              <Box width={600}>
                <TextInput
                  style={{ background: COLORS.white, width: "180px" }}
                  type="number"
                  value={data[value.key]}
                  onChange={(v) => onDataChange(value.key, v)}
                  containerStyle={classes.box}
                  suffix={value.suffix ? value.suffix : ""}
                />
              </Box>
            </Grid>
          </Grid>
        );
      })}
      <Grid container spacing={3} style={{ paddingBottom: 90 }}>
        <Grid item xs>
          <Typography variant="h5" className={classes.boldData}>
            Total Rental Operating Expenses
          </Typography>
        </Grid>
        <Grid item xs={8} className={classes.rightDiv}>
          <Typography variant="h5" className={classes.boldData}>
            {currencySymbol} XXX
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OperatingExpenses;
